import { Users as UsersWebsite } from "pages/web/userManagement/subpages/users/Users";
import { Users as UsersMobile } from "pages/mobile/userManagement/subpages/users/Users";
import { Resume as ResumeMobile } from "pages/mobile/userManagement/subpages/resume/Resume";
import { Resume as ResumeWebsite } from "pages/web/userManagement/subpages/resume/Resume";
import { Profiles as ProfilesWebsite } from "pages/web/userManagement/subpages/profiles/Profiles";
import { Clients as ClientsWebsite } from 'pages/web/userManagement/subpages/clients/Clients';
// import { Profiles as ProfilesMobile } from "pages/mobile/userManagement/subpages/profiles/Profiles";

const gettingSubPage = (subPage, mobile) => {
    switch (subPage) {
        case 'resume':
            return mobile ? <ResumeMobile /> : <ResumeWebsite />;

        case 'users':
            return mobile ? <UsersMobile /> : <UsersWebsite />;

        case 'profiles':
            return mobile ? <ProfilesWebsite /> : <ProfilesWebsite />;

        case 'clients':
            return mobile ? <ClientsWebsite /> : <ClientsWebsite />;

        default:
            return <> {`404 Subpage ${subPage} not found`} </>
    }
}

export { gettingSubPage };